import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import BookingUrlField from 'components/share-box/booking-url-field'
import BookingShareActions from 'components/share-box/booking-share-actions'
import CopyTextButton from '../copy-text-button'
import FileCopyOutlinedIcon from 'components/material-symbol/icons/FileCopy'

const ShareBookingUrlAndAccessCodeSection = ({ url, accessCode, title }) => {
  return (
    <Box display="flex" flexDirection="column" justifyContent="center">
      <BookingUrlField text={url} />
      <BookingShareActions url={url} title={title} />
      <Box display="flex" flexDirection="column" alignItems="center" mt={2}>
        <Typography variant="body2" color="textSecondary">
          Required Access Code:
        </Typography>
        <Box display="flex" alignItems="center" mb={2}>
          <Typography variant="h5">{accessCode}</Typography>
          <CopyTextButton component={IconButton} value={accessCode}>
            <FileCopyOutlinedIcon color="primary" />
          </CopyTextButton>
        </Box>
      </Box>
    </Box>
  )
}

export default ShareBookingUrlAndAccessCodeSection
